module.exports = __webpack_public_path__ + "img/customerManage.22658fc2.svg";